export default __webpack_public_path__ + "static/media/demostration.6a7f4250.svg";